import EventEmitter from "./EventEmitter";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { SVGLoader } from "three/examples/jsm/Addons.js";
import type { GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";

type ResourceSource = { name: string; type: string; path: string | string[] };

export default class Resources extends EventEmitter {
  sources: ResourceSource[];
  items: Record<string, unknown>;
  toLoad: number;
  loaded: number;
  loaders: { gltfLoader: GLTFLoader; textureLoader: THREE.TextureLoader; SVGLoader: SVGLoader } | null = null;

  constructor(sources: ResourceSource[]) {
    super();
    this.sources = sources;
    this.items = {};
    this.toLoad = this.sources.length;
    this.loaded = 0;

    this.setLoaders();
    this.startLoading();
  }

  setLoaders() {
    this.loaders = {
      gltfLoader: new GLTFLoader(),
      textureLoader: new THREE.TextureLoader(),
      SVGLoader: new SVGLoader(),
    };
  }

  startLoading() {
    for (const source of this.sources) {
      if (source.type === "gltfModel") {
        if (!this.loaders || typeof source.path !== "string") continue;
        this.loaders.gltfLoader.load(source.path, (file: GLTF) => {
          this.sourceLoaded(source, file);
        });
      } else if (source.type === "svg") {
        // no-op for now
      } else if (source.type === "texture") {
        if (!this.loaders || typeof source.path !== "string") continue;
        this.loaders.textureLoader.load(source.path, (file: THREE.Texture) => {
          this.sourceLoaded(source, file);
        });
      }
    }
  }

  sourceLoaded(source: ResourceSource, file: unknown) {
    this.items[source.name] = file;
    this.loaded++;

    if (this.loaded === this.toLoad) {
      this.trigger("ready");
    }
  }
}
